<div class="sar">
  <div class="hukuk-bas">
    <p class="etiket">Yasal</p>
    <h1 class="h1" style="font-size:clamp(30px,4vw,46px);margin-top:14px">Gizlilik Beyanı</h1>
    <p class="soluk" style="margin-top:12px;font-size:14.5px">Son güncelleme: 1 Ağustos 2026 · Okuma süresi ~4 dakika</p>
  </div>
  <div class="bol hukuk">
    <nav class="yan-icindekiler" aria-label="Bölümler">
      <ul>
        <li *ngFor="let b of bolumler">
          <a [href]="'#' + b.id" [class.on]="aktif === b.id" (click)="git($event, b.id)">{{ b.baslik }}</a>
        </li>
      </ul>
    </nav>
    <div>
      <p style="color:#3D4257;padding-bottom:20px;border-bottom:1px solid var(--cizgi)">pratiu olarak gizliliğinizi korumayı taahhüt ediyoruz. Bu beyan, kişisel verilerinizin nasıl toplandığını, kullanıldığını, saklandığını ve korunduğunu açıklar. Platformu kullanarak bu beyanı kabul etmiş olursunuz.</p>
      <div class="madde" id="g1"><h3><span>01</span> Toplanan bilgiler</h3>
        <ul>
          <li><b>Kullanıcı bilgileri:</b> ad, soyad, e-posta, telefon, kullanıcı adı ve şifre.</li>
          <li><b>Kullanım bilgileri:</b> tarayıcı türü, IP adresi, erişim saatleri, ziyaret edilen sayfalar.</li>
          <li><b>Ödeme bilgileri:</b> yalnızca ücretli hizmet satın alındığında, ödeme işlemi için gereken finansal veriler.</li>
          <li><b>Eğitim ve performans bilgileri:</b> sınav sonuçları, performans analizleri ve öğrenme hedefleri.</li>
        </ul>
      </div>
      <div class="madde" id="g2"><h3><span>02</span> Bilgilerin kullanımı</h3>
        <ul>
          <li><b>Hizmet sunumu:</b> platformu çalıştırmak, hesapları yönetmek, talep ettiğiniz hizmeti sağlamak.</li>
          <li><b>İletişim:</b> hizmet güncellemeleri ve destek.</li>
          <li><b>Analiz ve geliştirme:</b> deneyimi iyileştirmek ve yeni özellik geliştirmek.</li>
          <li><b>Yasal yükümlülükler:</b> mevzuata uymak ve hukuki süreçlere yanıt vermek.</li>
        </ul>
      </div>
      <div class="madde" id="g3"><h3><span>03</span> Bilgilerin paylaşımı</h3>
        <p>Kişisel bilgilerinizi üçüncü taraflarla yalnızca şu durumlarda paylaşırız: hizmetin sunulması için çalıştığımız hizmet sağlayıcılar; yasal yükümlülükler ve hukuki süreçler; şirket birleşmesi, satışı veya yeniden yapılandırılması hâlinde yeni sahip ya da ortaklar.</p>
      </div>
      <div class="madde" id="g4"><h3><span>04</span> Bilgilerin saklanması</h3>
        <p>Kişisel bilgilerinizi yalnızca yukarıda belirtilen amaçlar için gereken süre boyunca saklarız. Yasal yükümlülükler veya anlaşmazlıklar gibi sebeplerle daha uzun süreli saklama gerekebilir.</p>
      </div>
      <div class="madde" id="g5"><h3><span>05</span> Veri güvenliği</h3>
        <p>Endüstri standartlarına uygun güvenlik önlemleri uyguluyoruz. Ancak internet üzerinden veri iletiminin tamamen güvenli olduğu hiçbir sistemde garanti edilemez. Makul tedbirleri alır, ihlal durumunda sizi bilgilendiririz.</p>
      </div>
      <div class="madde" id="g6"><h3><span>06</span> Çerezler ve izleme teknolojileri</h3>
        <p>Deneyimi geliştirmek ve platformun nasıl kullanıldığını anlamak için çerez kullanırız. Çerezleri tarayıcı ayarlarınızdan devre dışı bırakabilirsiniz; bu durumda bazı özellikler tam çalışmayabilir.</p>
      </div>
      <div class="madde" id="g7"><h3><span>07</span> Haklarınız</h3>
        <p>Kişisel bilgilerinize erişme, düzeltme, silme veya işlenmesini kısıtlama hakkına sahipsiniz. Bu haklarınızı kullanmak için <a href="mailto:help@pratiu.com" style="color:var(--mor);text-decoration:underline">help@pratiu.com</a> adresine yazabilirsiniz.</p>
      </div>
      <div class="madde" id="g8"><h3><span>08</span> Beyanın değiştirilmesi</h3>
        <p>Bu beyanı zaman zaman güncelleyebiliriz. Değişiklik yapıldığında güncel metni platformda yayımlarız; kullanmaya devam etmeniz yeni beyanı kabul ettiğiniz anlamına gelir.</p>
      </div>
      <div class="madde" id="g9"><h3><span>09</span> İletişim</h3>
        <p>Beyanla ilgili sorularınız için <a href="mailto:help@pratiu.com" style="color:var(--mor);text-decoration:underline">help@pratiu.com</a>.</p>
      </div>
    </div>
  </div>
</div>
